import React from "react";

const base = process.env.REACT_APP_BACKEND_URL;
export const tileImg = (u) => (!u ? "" : u.startsWith("http") || u.startsWith("data:") ? u : `${base}${u}`);

const BAND = {
  drum_return: ["Return", "bg-[#22e05a] text-black"],
  drum_no_return: ["No Return", "bg-[#ffc8e6] text-black"],
  container_refund: ["REFUND", "bg-[#0b8a2e] text-white"],
};

// Access-style POS tile: square picture with the bold label laid over it, optional coloured band.
export const PosTile = ({ t, onClick, testid, className = "", children }) => {
  const band = BAND[t.band || t.kind];
  return (
    <div onClick={onClick} data-testid={testid} role="button"
      className={`relative aspect-square overflow-hidden rounded-[3px] border-2 border-slate-400 bg-white shadow-[2px_2px_0_rgba(0,0,0,0.25)] cursor-pointer select-none hover:border-sky-600 hover:brightness-105 active:translate-y-px transition-[filter,transform] ${className}`}>
      {t.image_url && <img src={tileImg(t.image_url)} alt="" draggable={false} onError={(e) => { e.currentTarget.style.display = "none"; }} className="absolute inset-0 h-full w-full object-cover" />}
      <div className="absolute inset-0 flex items-center justify-center p-1 text-center">
        <span className="font-black uppercase leading-[1.05] text-[13px] text-black break-words"
          style={{ textShadow: "0 0 3px #fff, 0 0 3px #fff, 0 0 6px #fff, 1px 1px 0 #fff, -1px -1px 0 #fff" }}>{t.label}</span>
      </div>
      {band && <div className={`absolute bottom-1 left-1 right-1 rounded-sm text-center text-[11px] font-black py-0.5 ${band[1]}`}>{band[0]}</div>}
      {children}
    </div>
  );
};
